// extracted by mini-css-extract-plugin
export var actionButton = "_aw-0";
export var attachmentLine = "_aw-1";
export var fileInput = "_aw-2";
export var fileUploadWrapper = "_aw-4";
export var footer = "_aw-3";
export var modalContent = "_aw-5";
export var paperclip = "_aw-6";
export var quillEditor = "_aw-7";